import { Injectable } from '@angular/core';
import { API } from 'src/app/configs';
import { HttpService } from 'src/app/core/http/http.service';
import { LeadStatus } from '../models/leadStatus';
import { GeneralService } from './general.service';

@Injectable({
    providedIn: 'root'
})
export class LeadService {

    constructor(
        protected gs: GeneralService,
        protected httpService: HttpService
    ) {

    }


    async setAction(event, item, action, owner_person_id = false, update = false) {
        event?.stopPropagation();

        this.gs.closeDropdown(event);

        let data: any = {
            ...(owner_person_id ? { owner_person_id: owner_person_id } : {}),
            public_idtext: item.public_idtext,
            update: item.update
        };

        switch (action) {
            case 'unread':
                this.updateData({
                    ...data,
                    status: 1
                }, update)
                    .then(r => {
                        item.status = 1;
                        item.statusObj = new LeadStatus().getStatus(item.status) || {};
                    });
                break;
            case 'read':
                this.updateData({
                    ...data,
                    status: 2
                }, update)
                    .then(r => {
                        item.status = 2;
                        item.statusObj = new LeadStatus().getStatus(item.status) || {};
                    });
                break;
            case 'archive':
                this.updateData({
                    ...data,
                    status: -1
                }, update)
                    .then(r => {
                        item.status = -1;
                        item.statusObj = new LeadStatus().getStatus(item.status) || {};
                    });
                break;
            case 'open':
                /*const modal = await this.modalController.create({
                    component: LeadsContentComponent,
                    cssClass: 'modal-transparency',
                    componentProps: {
                        data: { ...item, owner_person_id: this.companieSelData?.company_person_id || this.companieSelData }
                    }
                });

                modal.onDidDismiss().then((result: any) => {
                    
                    if (result?.data?.reload) {
                        this.loadData(null, 1);
                    }
                });
                
                return await modal.present();
                */
                break;
            case 'openUser':
                this.gs.navigate(['openModal', 'PersonComponent'], { queryParams: { json: JSON.stringify({ public_idtext: item.person_public_idtext }) } });
                //this.router.navigate([this.gs.getBase(),'person',item.person_public_idtext]);
                break;
            case 'share':
                this.share(event, item);
                break;
            case 'copy':
                this.gs.copyText(this.getLeadText(item));
                break;
        }
    }

    async updateData(data, reload) {
        return this.httpService.post<any>(API.general.lead.edit, data)
            .then(result => {
                if (reload) {
                    this.gs.transactionData.next({ method: 'leads', action: 'reloadData' });
                }

            })
            .catch(err => {
                console.log(err);
            });
    }

    share(event, item) {
        event?.stopPropagation();
        let text = this.getLeadText(item);
        window.open('https://wa.me/?text=' + window.encodeURIComponent(text), '_blank', 'location=yes');
    }

    getLeadText(item) {
        let text = '*LEAD*\n\n';

        if (item?.name)
            text += 'Nome: ' + item?.name + '\n\n';

        if (item?.source)
            text += 'Origem: ' + item?.source + '\n';

        if (item?.source_action)
            text += 'Ação: ' + item?.source_action + '\n';

        if (item?.type)
            text += 'Tipo: ' + item?.type + '\n';

        if (item?.cellphone)
            text += 'Celular: ' + item?.cellphoneMask + '\n';

        if (item?.email)
            text += 'E-mail: ' + item?.email + '\n';

        if (item?.message)
            text += 'Mensagem: ' + item?.message + '\n';

        if (!!item?.attachments?.length) {
            text += '\n*Anexos*:\n';
            item?.attachments.map(item => {
                text += item.name + ' - ' + item.file + '\n';
            });
        }

        if (item?.city)
            text += 'Cidade: ' + item?.city + ' / ' + item.state?.acronym + '\n';

        if (item?.company_creci_code)
            text += 'CRECI: ' + item?.company_creci_code + ' / ' + item.company_creci_state?.acronym + '\n';

        if (item?.document)
            text += 'Documento: ' + item?.document + '\n';

        if (item?.company_name)
            text += 'Empresa: ' + item?.company_name + '\n';

        if (item?.company_document)
            text += 'CNPJ: ' + item?.company_document + '\n';

        if (item?.position)
            text += 'Cargo: ' + item?.position + '\n';


        return text;

    }
}